module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/bar-services-tile-5e379e4deb62e637c0d48f37e9b04c08.jpg";